import { IRulesManagementStoreSegment } from './rulesManagement.interface';

export const rulesManagementStoreSelector = (state: IRulesManagementStoreSegment) => state.rulesManagement;
